import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, Row, Col, Button, Form, FormGroup, Label, Input, Spinner, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ApiService from '../services/ApiService';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useSelector } from 'react-redux';

const VideoMetadata = () => {
  const [broadcasts, setBroadcasts] = useState([]);
  const [selectedBroadcast, setSelectedBroadcast] = useState(null);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [selectedTenantFilter, setSelectedTenantFilter] = useState(null);
  const [titleSearch, setTitleSearch] = useState('');
  const { tenants } = useSelector(state => state.auth);
  const [formData, setFormData] = useState({
    tv_broadcast_id: '',
    broadcast_start: '',
    broadcast_end: '',
    source: '',
    channel: '',
    title: '',
    episode_country: '',
    episode_category: '',
    episode_class: '',
    event_category: '',
    event_class: '',
    event_title: '',
    event_city: '',
    event_country: '',
    stat_viewers_over_one_minute: null,
    stat_viewers_whole_broadcast: null,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoadingData(true);
    try {
      const broadcastsRes = await ApiService.getTvBroadcasts();
      setBroadcasts(broadcastsRes.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      video_id: formData.tv_broadcast_id,
      ...formData,
    }

    try {
      setLoadingCreate(true);
      await ApiService.createVideoMetadata(payload);
    }
    catch (e) {
      console.error("Error creating video metadata:", e);
      toast.error("Error creating video metadata");
    }
    setLoadingCreate(false);
  }

  const setBroadcast = (event) => {
    const broadcast = broadcasts.find(broadcast => broadcast.public_id === event.target.value);
    setFormData(prev => ({
      ...prev,
      tv_broadcast_id: broadcast.public_id,
      broadcast_start: format(new Date(broadcast.starts_at), 'yyyy-MM-dd HH:mm'),
      broadcast_end: format(new Date(broadcast.ends_at), 'yyyy-MM-dd HH:mm'),
      source: broadcast.source,
      channel: broadcast.channel,
      title: broadcast.title,
      episode_country: broadcast.country,
      episode_category: 'Football',
      episode_class: 'Men',
      event_category: broadcast.event?.category,
      event_class: broadcast.event?.class,
      event_title: broadcast.event?.title,
      event_city: broadcast.event?.city,
      event_country: broadcast.event?.country,
      stat_viewers_over_one_minute: '',
      stat_viewers_whole_broadcast: '',
    }));
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const updateBroadcast = async () => {
    const payload = {
      tenants: selectedBroadcast.tenants.map(tenant => tenant.value),
    };
    try {
      setLoadingUpdate(true);
      await ApiService.updateTvBroadcast(selectedBroadcast.public_id, payload);
      setSelectedBroadcast(null);
      await fetchData();
    } catch (err) {
      toast.error("Error updating broadcast");
    }
    setLoadingUpdate(false);
  }

  return (
    <>
      <div className="container-fluid">
        <Row>
          <Col xs={12} className="mb-4">
            <Card className="admin-card">
              <CardHeader className="admin-card-header">
                <h4 className="admin-card-title">Video metadata</h4>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Tv broadcast</Label>
                        <Input
                          type="select"
                          name="tv_broadcast_id"
                          value={formData.tv_broadcast_id}
                          onChange={setBroadcast}
                          required
                        >
                          <option value="">Select broadcast</option>
                          {broadcasts.map(broadcast => (
                            <option key={broadcast.public_id} value={broadcast.public_id}>
                              {broadcast.title}, {format(new Date(broadcast.starts_at), 'yyyy-MM-dd')} ({broadcast.public_id})
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Start Time</Label>
                        <Input
                          type="datetime-local"
                          name="broadcast_start"
                          value={formData.broadcast_start}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>End Time</Label>
                        <Input
                          type="datetime-local"
                          name="broadcast_end"
                          value={formData.broadcast_end}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Source</Label>
                        <Input
                          type="text"
                          name="source"
                          value={formData.source}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Channel</Label>
                        <Input
                          type="text"
                          name="channel"
                          value={formData.channel}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Title</Label>
                        <Input
                          type="text"
                          name="title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Episode Country</Label>
                        <Input
                          type="text"
                          name="episode_country"
                          value={formData.episode_country}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Episode Category</Label>
                        <Input
                          type="text"
                          name="episode_category"
                          value={formData.episode_category}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Episode Class</Label>
                        <Input
                          type="text"
                          name="episode_class"
                          value={formData.episode_class}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Event Category</Label>
                        <Input
                          type="text"
                          name="event_category"
                          value={formData.event_category}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Event Class</Label>
                        <Input
                          type="text"
                          name="event_class"
                          value={formData.event_class}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Event Title</Label>
                        <Input
                          type="text"
                          name="event_title"
                          value={formData.event_title}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Event City</Label>
                        <Input
                          type="text"
                          name="event_city"
                          value={formData.event_city}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Event Country</Label>
                        <Input
                          type="text"
                          name="event_country"
                          value={formData.event_country}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Stat Viewers Over One Minute</Label>
                        <Input
                          type="number"
                          name="stat_viewers_over_one_minute"
                          value={formData.stat_viewers_over_one_minute}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Stat Viewers Whole Broadcast</Label>
                        <Input
                          type="number"
                          name="stat_viewers_whole_broadcast"
                          value={formData.stat_viewers_whole_broadcast}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button type="submit" color="primary" disabled={loadingCreate}>
                    Create Broadcast
                    {loadingCreate && <Spinner size="sm" className="ml-2" />}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Modal isOpen={!!selectedBroadcast} toggle={() => setSelectedBroadcast(null)}>
            <ModalHeader toggle={() => setSelectedBroadcast(null)}>
              {selectedBroadcast?.title}
            </ModalHeader>
            <ModalBody>
              <Select
                className="react-select__container"
								classNamePrefix="react-select"
                onChange={(value) => setSelectedBroadcast(prev => ({
                  ...prev,
                  tenants: value,
                }))}
                isMulti
                options={tenants.map(tenant => ({
                  label: tenant.name,
                  value: tenant.id,
                }))}
                value={selectedBroadcast?.tenants}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={updateBroadcast} disabled={loadingUpdate}>
                Save
                {loadingUpdate && <Spinner size="sm" className="ml-2" />}
              </Button>
              <Button color="primary" onClick={() => setSelectedBroadcast(null)}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
          <Col xs={12}>
          <Card>
            <CardBody>
              <CardHeader style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <h4 className="admin-card-title" style={{margin: 0}}>Broadcasts</h4>
                  {loadingData ? <Spinner color="primary" className="ml-2" /> : null}
                </div>
                <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
                  <Input
                    type="text"
                    placeholder="Search by title..."
                    value={titleSearch}
                    onChange={(e) => setTitleSearch(e.target.value)}
                    style={{minWidth: '200px'}}
                  />
                  <div style={{minWidth: '200px'}}>
                    <Select
                      className="react-select__container"
                      classNamePrefix="react-select"
                      isClearable
                      placeholder="All Tenants"
                      value={selectedTenantFilter}
                      onChange={(value) => setSelectedTenantFilter(value)}
                      options={[...tenants]
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map(tenant => ({ label: tenant.name, value: tenant.id }))}
                    />
                  </div>
                </div>
              </CardHeader>
              <Table striped borderless>
                <thead>
                  <tr>
                    <th style={{ color: '#9d9d9d' }}>Date</th>
                    <th style={{ color: '#9d9d9d' }}>Title</th>
                    <th style={{ color: '#9d9d9d' }}>Source - Channel</th>
                    <th style={{ color: '#9d9d9d' }}>Event</th>
                    <th style={{ color: '#9d9d9d' }}>Tenants</th>
                  </tr>
                </thead>
                <tbody>
                  {broadcasts
                    .filter(broadcast => !selectedTenantFilter || broadcast.tenants.some(t => t.id === selectedTenantFilter.value))
                    .filter(broadcast => !titleSearch || broadcast.title?.toLowerCase().includes(titleSearch.toLowerCase()))
                    .map((broadcast) => (
                    <tr key={broadcast.id} style={{verticalAlign: 'middle'}}>
                      <td style={{verticalAlign: 'middle'}}>{format(new Date(broadcast.starts_at), 'yyyy-MM-dd HH:mm')}</td>
                      <td style={{verticalAlign: 'middle'}}>{broadcast.title}</td>
                      <td style={{verticalAlign: 'middle'}}>{broadcast.source} - {broadcast.channel}</td>
                      <td style={{verticalAlign: 'middle'}}>{broadcast.event.title}</td>
                      <td style={{verticalAlign: 'middle'}}>{broadcast.tenants.map(tenant => tenant.name).join(', ')}</td>
                      <td>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => setSelectedBroadcast({...broadcast, tenants: broadcast.tenants.map(tenant => ({label: tenant.name, value: tenant.id}))})}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
          </Col>
        </Row>

        <div style={{marginBottom: '64px'}} />
      </div>
    </>
  );
};

export default VideoMetadata; 